'use strict'

import { quoteService } from '@/_services'
import * as type from './types'
import i18n from '@/i18n'

const actions = {
  fetchQuoteList ( { commit }, { shipmentID }) {
    commit(type.QUOTE_LIST_CLEAR_ERROR)
    commit(type.QUOTE_LIST_FETCHING, { isFetching: true })
    quoteService.Quotes({shipmentID}).then((response) => {
      commit(type.SET_QUOTE_LIST, { quote: response })
    }).catch((error) => {
      console.log(error)
      commit(type.QUOTE_LIST_ERROR, { errors: error })
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
    }).finally(() => {
      commit(type.QUOTE_LIST_FETCHING, { isFetching: false })
    })
  },
  setQuoteRequests ({ commit }, { shipmentID, comment, requests, requestObject, transportType, incoterms,  originPort, originAddress, originCoordinates, destinationPort, destinationAddress, destinationCoordinates }) {
    commit(type.QUOTE_LIST_CLEAR_ERROR)
    commit(type.QUOTE_LIST_FETCHING, { isFetching: true })
    quoteService.createRequests({ shipmentID, comment, requests, transportType, incoterms,  originPort, originAddress, originCoordinates, destinationPort, destinationAddress, destinationCoordinates }).then((response) => {
      const data = response.data.createRequests.quoteIDs
      requestObject = requestObject.map((request, index) => {
        return { ...request, quoteID: data[index] }
      })
      commit(type.UPDATE_QUOTE_LIST, { requestObject })
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.request_created'), color: 'success' })
    }).catch((error) => {
      console.log(error)
      commit(type.QUOTE_LIST_ERROR, { errors: error })
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
    }).finally(() => {
      commit(type.QUOTE_LIST_FETCHING, { isFetching: false })
    })
  },
  handleRejectQuote ({commit}, {quoteID, shipmentID}) {
    commit(type.QUOTE_LIST_CLEAR_ERROR)
    commit(type.QUOTE_LIST_FETCHING, { isFetching: true })
    quoteService.rejectQuote({ shipmentID, quoteID }).then(() => {
      commit(type.QUOTE_REJECTED, {quoteID})
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.request_rejected'), color: 'success' })
    }).catch((error) => {
      console.log(error)
      commit(type.QUOTE_LIST_ERROR, { errors: error })
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
    }).finally(() => {
      commit(type.QUOTE_LIST_FETCHING, { isFetching: false })
    })

  },
  handleAcceptQuote ({ commit, dispatch }, { quoteID, shipmentID }) {
    commit(type.QUOTE_LIST_CLEAR_ERROR)
    commit(type.QUOTE_LIST_FETCHING, { isFetching: true })
    quoteService.acceptQuote({ shipmentID, quoteID }).then(() => {
      dispatch('shipmentsContext/setSelectedProviderFromQuotes', {
        shipmentID,
        providerID: quoteID,
        providerType: 'Quote'
      }, {root: true})
      commit(type.QUOTE_ACCEPTED, {quoteID})
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.request_accepted'), color: 'success' })
    }).catch((error) => {
      console.log(error)
      commit(type.QUOTE_LIST_ERROR, { errors: error })
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
    }).finally(() => {
      commit(type.QUOTE_LIST_FETCHING, { isFetching: false })
    })
  },
  handleCancelRequest ({commit}, {quoteID, shipmentID}) {
    commit(type.QUOTE_LIST_CLEAR_ERROR)
    commit(type.QUOTE_LIST_FETCHING, { isFetching: true })
    quoteService.cancelRequest({ shipmentID, quoteID }).then(() => {
      commit(type.REQUEST_CANCELED, {quoteID})
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.request_cancelled'), color: 'success' })
    }).catch((error) => {
      console.log(error)
      commit(type.QUOTE_LIST_ERROR, { errors: error })
      commit('SHOW_SNACKBAR', { message: i18n.t('snackbars.error'), color: 'error' })
    }).finally(() => {
      commit(type.QUOTE_LIST_FETCHING, { isFetching: false })
    })
  },
  clearQuoteList ({ commit }) {
    commit(type.SET_QUOTE_LIST, { quote: [] })
  }
}

export default actions
